import { offer, OFFER_ANCHOR } from '../data/offer';

export function getCheckoutHref(): string {
  return offer.checkoutUrl ?? OFFER_ANCHOR;
}

/** Amount without symbol, e.g. "27". */
export function getPriceNumber(): string | null {
  if (offer.price === null) return null;
  return Number.isInteger(offer.price) ? String(offer.price) : offer.price.toFixed(2);
}

/** Amount with symbol and currency code, e.g. "$27 USD". */
export function getFormattedPrice(): string | null {
  if (offer.price === null || !offer.currency) return null;
  const amount = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: offer.currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(offer.price);
  return `${amount} ${offer.currency}`;
}
